export function VideoSkeleton({ isLoading }: { isLoading: boolean }) {
  return (
    <div
      aria-hidden="true"
      className={[
        "pointer-events-none absolute inset-0 transition-opacity duration-500",
        isLoading ? "opacity-100" : "opacity-0",
      ].join(" ")}
    >
      <div className="absolute inset-0 bg-neutral-900" />
      <div className="absolute inset-0 animate-shimmer bg-[linear-gradient(105deg,transparent_40%,rgba(255,255,255,0.07)_50%,transparent_60%)] bg-[length:200%_100%]" />
    </div>
  );
}
